import { defaultTheme } from "@rentiohq/web-theme";

export const getArchivedBackground = () => defaultTheme.colors.gray[0];
